module.exports = __webpack_public_path__ + "images/emoji/baby_chick.cde2e44e8236718382dd.png";